import { createRouter, createWebHistory } from 'vue-router';

import Home from '@/views/Home.vue';
import Unauthorized from '@/views/Unauthorized.vue';
import Version from '@/views/Version.vue';
import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import OpenId from '@/views/OpenId.vue';
import TV1 from '@/views/tvs/Tv1.vue';
import TV2 from '@/views/tvs/Tv2.vue';
import TV3 from '@/views/tvs/Tv3.vue';
import TV4 from '@/views/tvs/Tv4.vue';

import Admin from '@/views/admin';
import AdminStudyList from '@/views/admin/StudyList';
import AdminFormUploadCSV from '@/views/admin/Form/UploadCSV';
import AdminFormUpdateFilters from '@/views/admin/Form/UpdateFilters';
import AdminFormCurrentSites from '@/views/admin/Form/CurrentSites';
import AdminFormEditAddresses from '@/views/admin/Form/EditAddresses';
import AdminFormEditRegions from '@/views/admin/Form/EditRegions';
import AdminFormEditDetails from '@/views/admin/Form/EditDetails';
import AdminFormSummary from '@/views/admin/Form/Summary';
import AdminFormStatus from '@/views/admin/Form/Status';

import UserLayout from '@/views/user/Layout';
import UserLogin from '@/views/user/Login';
import UserRegister from '@/views/user/Register';
import UserRegisterSecretQuestion from '@/views/user/RegisterSecretQuestion';
import UserForgetPassword from '@/views/user/ForgetPassword';
import UserForgetPasswordSecretQuestion from '@/views/user/ForgetPasswordSecretQuestion';
import UserForgetCompleted from '@/views/user/ForgetPasswordCompleted';
import UserResetPassword from '@/views/user/ResetPassword';
import UserCompleted from '@/views/user/Completed';

import Cookies from '@/views/Cookies';
import Legal from '@/views/Legal';
import Confidentiality from '@/views/Confidentiality';

import { ResultRoute } from '@/router/Result';
import { ExportRoute } from '@/router/Export';
import { TvTestRoute } from '@/router/TvTest';

import Report from '@/views/Report';

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: Unauthorized,
    },
    {
      path: '/cookies',
      name: 'Cookies',
      component: Cookies,
      meta: {
        topbar: true,
        backable: true,
      },
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal,
      meta: {
        topbar: true,
        backable: true,
      },
    },
    {
      path: '/confidentiality',
      name: 'Confidentiality',
      component: Confidentiality,
      meta: {
        topbar: true,
        backable: true,
      },
    },
    {
      path: '/exports/:exportId/print',
      name: 'Report',
      component: Report,
    },
    {
      path: '/user/result/:studyId',
      name: 'userResult',
      component: Home,
      meta: {
        topbar: true,
      },
    },
    {
      path: '/user',
      name: 'user',
      component: UserLayout,
      children: [
        {
          path: 'login',
          name: 'userLogin',
          component: UserLogin,
        },
        {
          path: 'forgetPassword',
          name: 'userForgetPassword',
          component: UserForgetPassword,
        },
        {
          path: 'forgetPassword/:emailKey/completed',
          name: 'userForgetCompleted',
          component: UserForgetCompleted,
        },
        {
          path: 'resetPassword/:token',
          name: 'userForgetPasswordSecretQuestion',
          component: UserForgetPasswordSecretQuestion,
        },
        {
          path: 'resetPassword/:token/setPassword',
          name: 'userResetPassword',
          component: UserResetPassword,
        },
        {
          path: 'register/:emailKey',
          name: 'userRegister',
          component: UserRegister,
        },
        {
          path: 'register/:emailKey/secretQuestion',
          name: 'userRegisterSecretQuestion',
          component: UserRegisterSecretQuestion,
        },
        {
          path: 'completed',
          name: 'userCompleted',
          component: UserCompleted,
        },
      ],
    },
    ResultRoute,
    {
      path: '/version',
      name: 'Version',
      component: Version,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '/openId',
      name: 'OpenId',
      component: OpenId,
    },
    {
      path: '/tv1',
      name: 'Tv1',
      component: TV1,
    },
    {
      path: '/tv2',
      name: 'Tv2',
      component: TV2,
    },
    {
      path: '/tv3',
      name: 'Tv3',
      component: TV3,
    },
    {
      path: '/tv4',
      name: 'Tv4',
      component: TV4,
    },
    TvTestRoute,
    ExportRoute,
    {
      path: '/',
      name: 'studyList',
      component: AdminStudyList,
      meta: {
        topbar: true,
      },
    },
    {
      path: '/admin/',
      component: Admin,
      redirect: '/study/list',
      meta: {
        topbar: true,
      },
      children: [
        {
          path: 'study/upload-csv/:studyId',
          name: 'studyUploadCSV',
          component: AdminFormUploadCSV,
          meta: {
            breadcrumbLevel: 0,
            topbar: true,
            closable: true,
          },
        },
        {
          path: 'study/update-filters/:studyId',
          name: 'studyUpdateFilters',
          component: AdminFormUpdateFilters,
          meta: {
            breadcrumbLevel: 0,
            topbar: true,
            closable: true,
          },
        },
        {
          path: 'study/current-sites/:studyId',
          name: 'studyCurrentSites',
          component: AdminFormCurrentSites,
          meta: {
            breadcrumbLevel: 1,
            topbar: true,
            closable: true,
          },
        },
        {
          path: 'study/edit-addresses/:studyId',
          name: 'studyEditAddresses',
          component: AdminFormEditAddresses,
          meta: {
            breadcrumbLevel: 2,
            topbar: true,
            closable: true,
          },
        },
        {
          path: 'study/edit-regions/:studyId',
          name: 'studyEditRegions',
          component: AdminFormEditRegions,
          meta: {
            breadcrumbLevel: 3,
            topbar: true,
            closable: true,
          },
        },
        {
          path: 'study/edit-details/:studyId',
          name: 'studyEditDetails',
          component: AdminFormEditDetails,
          meta: {
            breadcrumbLevel: 4,
            topbar: true,
            closable: true,
          },
        },
        {
          path: 'study/summary/:studyId',
          name: 'studySummary',
          component: AdminFormSummary,
          meta: {
            breadcrumbLevel: 5,
            topbar: true,
            closable: true,
          },
        },
        {
          path: 'study/status/:studyId',
          name: 'studyStatus',
          component: AdminFormStatus,
          meta: {
            breadcrumbLevel: -1,
            topbar: true,
            closable: true,
          },
        },
      ],
    },
  ],
});
